import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Flag } from '@daedalus/atlas/Flag';
import { Text } from '@daedalus/atlas/Text';
import { getCountryCodeFromLanguage } from '@daedalus/core/src/localization/services/country';
import { splitPopularAndOtherLanguages } from '@daedalus/core/src/localization/services/locale';
import { LanguageType } from '@daedalus/core/src/localization/types/LanguageType';
import { SearchInput } from '../../SearchInput';
import { SelectorList } from '../SelectorList/SelectorList';
interface Props {
  isMobile?: boolean;
  value: string;
  onChange: (code: string) => void;
  languages: LanguageType[];
  onSearchInputFocus?: () => void;
}
const _exp = /*#__PURE__*/() => Text;
const LanguageName = /*#__PURE__*/styled(_exp())({
  name: "LanguageName",
  class: "l1wadvjg",
  propsAsIs: true
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w14k96fy",
  propsAsIs: false
});
const splitPopularAndOther = (items: LanguageType[]) => {
  const {
    languagesList,
    popularLanguagesList
  } = splitPopularAndOtherLanguages(items);
  return {
    itemsList: languagesList,
    popularItemsList: popularLanguagesList
  };
};
export const LanguageSelector: React.FC<Props> = ({
  isMobile = false,
  languages,
  onChange,
  value,
  onSearchInputFocus
}) => {
  const {
    formatMessage
  } = useIntl();
  const sortedLanguages = useMemo(() => {
    const result = [...languages];
    result.sort((a, b) => a.name.localeCompare(b.name));
    return result;
  }, [languages]);
  const renderList = (items: LanguageType[], isSearching = false) => <SelectorList isMobile={isMobile} items={items} value={value} onChange={onChange} getValue={item => item.code} popularItemsTitle={formatMessage({
    id: 'popularLanguages',
    defaultMessage: 'Popular languages'
  })} otherItemsTitle={formatMessage({
    id: 'allLanguages',
    defaultMessage: 'All languages'
  })} splitPopularAndOther={splitPopularAndOther} renderItem={(item, isMobile) => <Wrapper className={cx(isMobile && 'isMobile')}>
          <Flag countryCode={getCountryCodeFromLanguage(item.code)} />
          <LanguageName variant={isMobile ? 'bodyM' : 'bodyS'} className={cx(isMobile && 'isMobile')} colorPath="content.neutral.c999">
            {item.displayName}
          </LanguageName>
        </Wrapper>} isSearching={isSearching} />;
  if (isMobile) {
    return <SearchInput items={sortedLanguages} itemMatcher={SearchInput.matchers.default(['displayName', 'code', 'name'])} onFocus={onSearchInputFocus}>
        {renderList}
      </SearchInput>;
  }
  return renderList(languages);
};

require("./LanguageSelector.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LanguageSelector.tsx");